// @flow
import React from 'react';
import Group from 'sail/Group';
import {ClientSetting} from './components/ClientSetting';
import {ServerSetting} from './components/ServerSetting';

export const WEB_DYNAMIC_ONLY_SETTINGS = {
  platforms: ['web'],
  clients: {web: ['html', 'react']},
  servers: ['ruby', 'node', 'php', 'python'],
};

export const WebDynamicOnlySettings = () => {
  return (
    <Group direction="horizontal" alignItems="center" spacing={24}>
      <ClientSetting clients={WEB_DYNAMIC_ONLY_SETTINGS.clients} />
      <ServerSetting servers={WEB_DYNAMIC_ONLY_SETTINGS.servers} />
    </Group>
  );
};
